import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getParentWaitingList } from '../../services/firestore';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ParentWaitlists = () => {
  const { currentUser } = useAuth();
  const [waitlists, setWaitlists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWaitlists = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getParentWaitingList(currentUser.uid);
        setWaitlists(data || []);
      } catch (err) {
        setError('Failed to load waitlists.');
      } finally {
        setLoading(false);
      }
    };
    if (currentUser?.uid) fetchWaitlists();
  }, [currentUser]);

  return (
    <div className="page-container">
      <h1 className="page-title">My Waitlists</h1>
      {loading ? (
        <div className="loading-container"><p>Loading waitlists...</p></div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : waitlists.length === 0 ? (
        <div className="empty-state">
          <p>You haven't joined any waitlists yet.</p>
          <Link to="/parent/search/providers" className="btn btn-primary">Find Providers</Link>
        </div>
      ) : (
        <div className="waitlist-providers-list">
          {waitlists.map(waitlist => (
            <div className="waitlist-provider-card" key={waitlist.id}>
              <div className="waitlist-provider-header">
                <h3>{waitlist.provider?.name || 'Unknown Provider'}</h3>
                <div className="waitlist-status">
                  <span className={`status-badge status-${waitlist.status || 'pending'}`}>{waitlist.status || 'Pending'}</span>
                </div>
              </div>
              <div className="waitlist-provider-body">
                {waitlist.provider && (
                  <>
                    <p className="waitlist-provider-address">
                      <FaMapMarkerAlt className="icon" />
                      {waitlist.provider.address || 'Address not provided'}
                    </p>
                    <div className="waitlist-provider-child">
                      <p><strong>Child:</strong> {waitlist.childData?.name || 'Not specified'}</p>
                      {waitlist.position && (
                        <p><strong>Position:</strong> {waitlist.position}</p>
                      )}
                      <p><strong>Requested:</strong> {waitlist.createdAt ? new Date(waitlist.createdAt.seconds * 1000).toLocaleDateString() : 'Unknown date'}</p>
                    </div>
                  </>
                )}
              </div>
              <div className="waitlist-provider-actions">
                <Link to={`/provider/${waitlist.provider?.id || waitlist.providerUid}`} className="btn btn-outline btn-sm">View Provider</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentWaitlists; 